<template>
  <div class="login-box">
    <div class="login-logo">
      <b>AGS BP Batam</b>
    </div>
    <!-- /.login-logo -->
    <div class="card">
      <div class="card-body login-card-body">
        <p class="login-box-msg">Sign in to start your session</p>

        <form @submit="submitLogin" method="post">

          <div class="input-group mb-3">
            <input type="text" class="form-control" placeholder="Username" v-model="username">
            <div class="input-group-append">
              <div class="input-group-text">
                <span class="fas fa-user"></span>
              </div>
            </div>
          </div>
          <div class="input-group mb-3">
            <input type="password" class="form-control" placeholder="Password" v-model="password">
            <div class="input-group-append">
              <div class="input-group-text">
                <span class="fas fa-lock"></span>
              </div>
            </div>
          </div>
          <div class="row">
            <!-- /.col -->
            <div class="col-12">
              <button type="submit" class="btn btn-primary btn-block">Sign In</button>
            </div>
            <!-- /.col -->
          </div>
        </form>
        <p class="mt-3 mb-0">
          <b-link :to="{name: 'Register' }">
            Register a new member
          </b-link>
        </p>
      </div>
      <!-- /.login-card-body -->
    </div>
  </div>
  <!-- /.login-box -->
</template>

<script>
import {login} from "@/services/login";
import {setUserToken} from "@/helpers/Utils";
import {getUser} from "@/services/users";
import { BLink } from 'bootstrap-vue';
import {getMemberByID} from "@/services/members";

export default {
  name: "Login",
  components: { BLink },
  data: ()=>({
    username: null,
    password: null,
  }),
  methods: {
    async submitLogin(e) {
      try {
        e.preventDefault();
        const {data: {data: {login: res}}} = await login({
          username: this.username,
          paswd: this.password,
        })
        setUserToken(res.token);
        const {data: {data: {rows: {user}}}} = await getUser(res.username);
        const {data: {data: members }} = await getMemberByID(user.member);
        user.company = null;
        if (members && Object.prototype.hasOwnProperty.call(members, 'rows')) {
          user.company = members.rows.member;
        }
        await this.$store.dispatch('user/USER_LOGGED_IN', user);
        await this.$router.replace({ name: 'Dashboard' })
        this.$bvToast.toast(`You have successfully logged in as ${user.username}. Now you can start to explore!`,{
          title: `Welcome ${user.username}!`,
          autoHideDelay: 1500,
          variant: 'success',
        })
      } catch (err) {
        // this.$bvToast.toast(`Error: ${err.message}`,{
        //   title: `Error`,
        //   autoHideDelay: 1500,
        //   variant: 'danger',
        // })
        console.error(err)
      }
    },
  },
  created() {
    document.body.className = 'login-page';
  },
}
</script>

<style scoped>

</style>
